import { getSavedSourceSystemConfig, type SourceSystemConfig } from "@/config/sourceSystem";

const DEFAULT_FAVICON_URL = "/logo.svg";

export function getSavedBrandConfig(): SourceSystemConfig {
  return getSavedSourceSystemConfig();
}

export function applyDocumentBrand(config: SourceSystemConfig = getSavedBrandConfig()): void {
  document.title = config.title;

  let favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }

  favicon.href = config.logoUrl ?? DEFAULT_FAVICON_URL;
  favicon.type = config.logoUrl ? "image/png" : "image/svg+xml";
}
